import React from 'react';
import { Badge, Button, Col, Input, Row } from 'reactstrap';
import { formatDate } from 'utils/date';
import { validateWholeNumber } from 'utils/functions';
import {
  SATextInput,
  SATextInputValidate,
  SimpleFormatPhone,
  validateEmail,
  validatePhoneNumber
} from 'utils/functions';

const UserCard = ({
  user,
  updateAdminUser,
}) => {
  return (
    <>
      <Row>
        <Col md="8">
          <h5 className="section-heading">
            {user.name}
          </h5>
        </Col>

          <Col md="4" style={{textAlign:"right"}}>
            <Button
              color={user.enabled ? "danger" : "success"}
              onClick={() => {
                updateAdminUser(user, {
                  enabled: !user.enabled,
                });
            }}
              className="toggle-status-btn"
              >
                {user.enabled ? "Disable" : "Enable"} User
            </Button>
          </Col>
      </Row>
      <Row>
        <Col>
          <Badge color={user.enabled ? "success" : "danger"} className="status-badge">
            {user.enabled ? "Active" : "Disabled"}
          </Badge>
        </Col>
      </Row>

      <Row className="info-row">
        <Col>
          <label className="label">User ID</label>
          <Input type="text" readOnly value={user.userid} />
        </Col>
      </Row>

      <Row className="info-row">
        <Col lg="6" md="6">
          <label className="label">
            <span>Phone </span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              className="bi bi-pencil"
              viewBox="0 0 16 16"
              style={{ cursor: "pointer" }}
              onClick={() => {
                SATextInputValidate("Update phone", "User phone...", user.phone ?? "", validatePhoneNumber, "Invalid phone number")
                  .then((res) => {
                    if (res) {
                    updateAdminUser(user, {
                      phone: res,
                    });
                    }
                  });
              }}
            >
              <path d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168zM11.207 2.5 13.5 4.793 14.793 3.5 12.5 1.207zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293zm-9.761 5.175-.106.106-1.528 3.821 3.821-1.528.106-.106A.5.5 0 0 1 5 12.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.468-.325" />
            </svg>
          </label>
          <Input type="text" readOnly value={SimpleFormatPhone(user.phone)} />
        </Col>
        <Col lg="6" md="6">
          <label className="label">
            <span>Email </span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              className="bi bi-pencil"
              viewBox="0 0 16 16"
              style={{ cursor: "pointer" }}
              onClick={() => {
                SATextInputValidate("Update email", "User email...", user.email ?? "", validateEmail, "Invalid email format")
                  .then((res) => {
                    if (res) {
                    updateAdminUser(user, {
                      email: res,
                    });
                    }
                  });
              }}
            >
              <path d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168zM11.207 2.5 13.5 4.793 14.793 3.5 12.5 1.207zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293zm-9.761 5.175-.106.106-1.528 3.821 3.821-1.528.106-.106A.5.5 0 0 1 5 12.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.468-.325" />
            </svg>
          </label>
          <Input type="text" readOnly value={user.email} />
        </Col>
      </Row>

      <Row className="info-row">
        <Col lg="6" md="6">
          <label className="label">
            <span>Username </span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              className="bi bi-pencil"
              viewBox="0 0 16 16"
              style={{ cursor: "pointer" }}
              onClick={() => {
                SATextInput("Update username", "User username...", user.username ?? "")
                  .then((res) => {
                    if (res) {
                    updateAdminUser(user, {
                      username: res,
                    });
                    }
                  });
              }}
            >
              <path d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168zM11.207 2.5 13.5 4.793 14.793 3.5 12.5 1.207zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293zm-9.761 5.175-.106.106-1.528 3.821 3.821-1.528.106-.106A.5.5 0 0 1 5 12.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.468-.325" />
            </svg>
          </label>
          <Input type="text" readOnly value={user.username} />
        </Col>
        <Col lg="6" md="6">
          <label className="label">
            <span>Permissions </span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              className="bi bi-pencil"
              viewBox="0 0 16 16"
              style={{ cursor: "pointer" }}
              onClick={() => {
                SATextInputValidate("Update permissions", "User permissions...", user.permissions ?? "", validateWholeNumber, "Must be a whole number")
                  .then((res) => {
                    if (res) {
                    updateAdminUser(user, {
                      permissions: res,
                    });
                    }
                  });
              }}
            >
              <path d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168zM11.207 2.5 13.5 4.793 14.793 3.5 12.5 1.207zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293zm-9.761 5.175-.106.106-1.528 3.821 3.821-1.528.106-.106A.5.5 0 0 1 5 12.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.468-.325" />
            </svg>
          </label>
          <Input type="text" readOnly value={user.permissions} />
        </Col>
      </Row>

      <Row className="info-row">
        <Col md="6">
          <label className="label">Created</label>
          <Input type="text" readOnly value={user.datetimecreated ? formatDate(user.datetimecreated) : ""} />
        </Col>
        <Col md="6">
          <label className="label">Updated</label>
          <Input type="text" readOnly value={user.datetimeupdated ? formatDate(user.datetimeupdated) : ""} />
        </Col>
      </Row>

    </>
  );
};

export default UserCard;